import React, { useMemo } from 'react';
import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
  useTheme,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import AdcoComparisonChart from './AdcoComparisonChart';

export default function AdcoGraphModal({ open, onClose, adcoData, tranches }) {
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';
  const scenarios = useMemo(() => ({ ADCO: { adco: adcoData || [] } }), [adcoData]);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="lg"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 3,
          minHeight: '600px',
        },
      }}
    >
      <DialogTitle
        sx={{
          bgcolor: theme.palette.primary.main,
          color: theme.palette.primary.contrastText,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          py: 2,
        }}
      >
        <Typography component="span" variant="h6" sx={{ fontWeight: 600 }}>
          ADCO Metric Chart
        </Typography>
        <IconButton
          aria-label="Close ADCO chart"
          onClick={onClose}
          sx={{ color: theme.palette.primary.contrastText }}
          size="small"
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent
        sx={{
          p: 3,
          bgcolor: isDark ? theme.palette.background.default : theme.palette.grey[50],
        }}
      >
        <AdcoComparisonChart scenarios={scenarios} tranches={tranches} />
      </DialogContent>
    </Dialog>
  );
}
